<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.21977 4.21977C4.51279 3.92674 4.98788 3.92674 5.2809 4.21977L11.9979 10.9368L18.7191 4.21977C19.0121 3.92674 19.4872 3.92674 19.7802 4.21977C20.0733 4.51279 20.0733 4.98788 19.7802 5.2809L13.0591 11.9979L19.7802 18.7191C20.0733 19.0121 20.0733 19.4872 19.7802 19.7802C19.4872 20.0733 19.0121 20.0733 18.7191 19.7802L11.9979 13.0591L5.2809 19.7802C4.98788 20.0733 4.51279 20.0733 4.21977 19.7802C3.92674 19.4872 3.92674 19.0121 4.21977 18.7191L10.9368 11.9979L4.21977 5.2809C3.92674 4.98788 3.92674 4.51279 4.21977 4.21977Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
